export class InjectableClass {
  constructor(injections, options) {
    // Assign given injections to the classes instance
    this.constructor.injectArguments(this, injections, options);
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/lib-injection/src/injectableClass.js